<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="6">
        <v-tabs v-model="filterBy">
          <v-tab>{{ $t('claimforms.tabs.unsigned') }}</v-tab>
          <v-tab>{{ $t('claimforms.tabs.signed') }}</v-tab>
        </v-tabs>
      </v-col>

      <v-col cols="12" md="6" v-if="!filterBy">
        <div class="text-end">
          <v-btn color="primary" class="mr-2" :disabled="!selectedUnsigned.length" @click="onSignForm(selectedUnsigned[0])">{{ $t('claimforms.menu.sign') }}</v-btn>
          <v-btn :disabled="!selectedUnsigned.length" @click="onCancelForm(selectedUnsigned[0])">{{ $t('claimforms.menu.cancel') }}</v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
            :show-select="!filterBy"
            :single-select="true"
            v-model="selectedUnsigned"
            dense
            item-key="id"
            :items="visibleClaimforms"
            :loading="loading"
            :headers="headers"
            :page.sync="currentPage"
            :items-per-page.sync="itemsPerPage"
            :footer-props="{itemsPerPageOptions: [50, 100, 200, 500, 2000, 5000]}"
            @click:row="openRights"
        >

          <template v-slot:item.actions="{ item }">

            <v-menu v-if="!filterBy">
              <template v-slot:activator="{on, attrs}">
                <v-btn icon v-on="on" v-bind="attrs">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item
                    v-for="action in getActions(item)"
                    :key="action"
                    @click="onMenuClick(item, action)"
                >
                  <v-list-item-title>
                    {{ $t(`claimforms.menu.${action}`) }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-btn v-else icon @click.stop="doDownload(item)">
              <v-icon>mdi-download</v-icon>
            </v-btn>

          </template>

        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="signForm" width="50%" max-width="700px">
      <SignForm @close="signForm = false;" v-if="signForm" :item="currentClaimform" @signed="reloadItems"/>
    </v-dialog>

    <v-dialog v-model="rightsListVisible" width="90%" scrollable>
      <ClaimformRights
          :item="currentClaimform"
          v-if="rightsListVisible"
          @close="rightsListVisible = false;"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import RightsholderInitedDataDrivenMixin from "@/components/mixins/RightsholderInitedDataDrivenMixin";
import SignForm from "@/components/claimforms/SignForm";
import ClaimformRights from "@/components/claimforms/ClaimformRights";
import downloadFile from "@/utils/downloadFile";

export default {
  name: "ClaimForms",
  components: {ClaimformRights, SignForm},
  data() {
    return {
      loading: true,
      currentPage: 1,
      itemsPerPage: 100,
      signForm: false,
      rightsListVisible: false,
      currentClaimform: null,
      filterBy: 0,
      selectedUnsigned: []
    }
  },
  mixins: [RightsholderInitedDataDrivenMixin],
  computed: {
    visibleClaimforms() {
      const f = (status) => (this.filterBy === 0 ? Number(status) === 0 : Number(status) !== 0);
      return this.claimformsList.filter(({signStatus}) => f(signStatus));
    },
    claimformsList() {
      return this.$store.getters["app/claimforms"].list || [];
    },
    headers() {
      const getCol = (value) => ({value, text: this.$t(`claimforms.columns.${value}`)});
      return [
        'rowNumber',
        'id',
        'ityp',
        'signStatus',
        'openedDateFormatted',
        'signedDateFormatted',
        'signedBy',
        'details',
        'rader',
        'raderFel',
        'raderMak'
      ].map(getCol)
        .concat([
          this.filterBy ? {
            value: 'actions',
            sortable: false,
          } : {}]);
    }
  },
  watch: {
    filterBy() {
      this.reloadItems();
    }
  },
  methods: {
    reloadItems() {
      this.loading = true;
      this.$store.dispatch('app/loadClaimforms', {reload: true})
        .finally(() => {
          this.loading = false;
        });
    },

    onSignForm(item) {
      this.currentClaimform = item;
      this.signForm = true;
    },

    onCancelForm(item) {
      const actions = {
        back: this.$t('claimforms.cancel.back'),
        remove: this.$t('claimforms.cancel.remove'),
        cancel: this.$t('app.no')
      }
      this.$dialog.confirm({
        text: this.$t('claimforms.confirmCancel'),
        actions: [{
          text: actions.back,
          color: 'primary'
        }, {
          text: actions.remove,
          color: 'primary'
        }, {
          text: actions.cancel,
          color: 'secondary'
        }]
      })
        .then((response) => {
          // eslint-disable-next-line no-unreachable
          if (response === actions.back) {
            this.cancelForm(item);
          }
          if (response === actions.remove) {
            this.cancelForm(item, true)
          }
        })
    },

    cancelForm(item, remove = false) {
      this.$store.dispatch('app/cancelClaimform', {item, remove});
    },

    openRights(item) {
      this.rightsListVisible = true;
      this.currentClaimform = item;
    },

    doDownload(item) {
      this.currentClaimform = item;
      this.$store.dispatch('app/getClaimformDetailsDownloadUrl', {clnr: item.id, format: 'xlsx'})
        .then((res) => {
          downloadFile((res.filename ? res.filename : 'claims.xlsx'), res.url);
        })
    },

    getActions({signStatus}) {
      return Number(signStatus) ? ['rights','download'] : ['rights', 'sign', 'cancel','download'];
    },

    onMenuClick(item, action) {
      switch (action) {
        case 'rights':
          this.openRights(item);
          break;
        case 'sign':
          this.onSignForm(item);
          break;
        case 'cancel':
          this.onCancelForm(item);
          break;
        case 'download':
          this.doDownload(item);
          break;
      }
    }
  },
}
</script>